export default {
        order: {
            cancel: 'Kanselahin ang order',
            payment: 'magbayad ngayon',
            remind: 'paalalahanan ang paghahatid',
            return: 'Mag-apply para sa return',
            confirm: 'Kumpirmahin ang resibo',
            evaluate: 'Suriin ngayon',
            logistics: 'Tingnan ang logistik',
            noRefund: 'Walang refund',
            refunding: 'pag-refund',
            refundSuccess: 'Tagumpay ang refund',
            refundFail: 'Nabigo ang refund'
        },
        cancelOrderMap: {
            0: "Ayoko na",
            1: 'Maling produkto',
            2: 'Ulitin ang order',
            3: 'Hindi makapirma para sa resibo',
            4: 'Iba pang mga dahilan',
        },
        "获取验证码": "pagkamantala",
        "验证码": "kodigo",
        "请输入验证码": "Pakilagay ang kodigo",
        "发送": "I-send",
        "已发送，请注意查收":
            "Ilagay na, hindi makakapag-send",
        "1": "maling produkto",
        "2": "Duplicate na order",
        "3": "Hindi makapirma",
        "4": "iba pang mga dahilan",
        "联系商家": "makipag-ugnayan sa merchant",
        "当前余额": "kasalukuyang balanse",
        "请输入完整的支付密码!": "Pakilagay ang kumpletong password sa pagbabayad!",
        "加值": "bonus",
        "备注": "Tandaan",
        "银行卡": "Bank card",
        "平台人工发起退款": "Ang platform ay manu-manong nagpapasimula ng refund",
        "提领": "Umorder",
        "用户未发表评论": "Hindi nagkomento ang user",
        "订单": "Umorder",
        "下单成功，等待付款": "Matagumpay na nailagay ang order, naghihintay ng bayad",
        "下单成功，付款成功": "Matagumpay na nailagay ang order at matagumpay ang pagbabayad",
        "已发货，正在运输中": "Ipinadala at nasa transit",
        "订单已取消，原因:手动发起取消订单": "Kinansela ang order, dahilan: manual na simulan ang pagkansela ng order",
        "订单已取消，原因:超时自动取消订单": "Kinansela ang order, dahilan: awtomatikong kanselahin ang order sa overtime",
        "商家已确认，已进入备货状态": "Nakumpirma na ng merchant at pumasok na sa estado ng stocking",
        "系统发货成功": "Matagumpay na naipadala ang supplier",
        "订单已签收": "Napirmahan na ang order",
        "发起退款申请": "Magsimula ng kahilingan sa refund",
        "退款成功": "Matagumpay na mag-refund",
        "退款失败": "Nabigo ang refund",
        "订单退款成功": "Matagumpay na na-refund ang order",
        "订单退款失败": "Nabigo ang refund ng order",
        "系统默认好评": "Default na papuri ng system",
        "请输入关键字搜索": "Mangyaring magpasok ng mga keyword na hahanapin",
        "充值金额不能小于1": "Ang halaga ng recharge ay hindi maaaring mas mababa sa 1 (kabilang ang dalawang decimal na lugar)",
        "猜你喜欢": "baka magustuhan mo rin",
        "订单已完成": "natapos ang order",
        "热销推荐": "Mainit na Inirerekomenda",
        "头像选择": "Pagpili ng Avatar",
        "修改头像": "Baguhin ang avatar",
        "KEY": "Pinasimpleng Chinese (cn)",
        "-连接已建立-": "-natatag ang koneksyon-",
        ",才可提币": ", para mag-withdraw ng mga barya",
        "[code]值错误": "[code] maling halaga",
        "[symbol]参数为空": "Walang laman ang parameter ng [symbol].",
        "goodsFreightTips1": "1. Komposisyon ng cross-border commodity freight: kargamento = bayad sa paghahatid + kargamento sa malayong distansya + bayad sa paghahatid",
        "creditQuotaINFO": "100,000 hanggang 30,000,000, ang halaga ay flexible, walang limitasyon, at ang pinakamahabang panahon ng pautang ay isang taon.",
        "authentic": "100% tunay",
        "homeIconTips1": "100% tunay",
        "goodsFreightTips2": "2. Kung ang kondisyon ng libreng pagpapadala ay hindi natugunan, ang bayad sa pagpapadala ay sisingilin ayon sa aktwal na produkto",
        "goodsFreightTips3": "3. Ang pangwakas na karapatan sa pagpapakahulugan ay kabilang sa plataporma",
        "dayReturns7": "7 araw na pagbabalik",
        "homeIconTips2": "7 araw na pagbabalik",
        "homeIconTips4": "ligtas na pagbabayad",
        "safe": "ligtas at walang pag-aalala",
        "safePayment": "ligtas na pagbabayad",
        "homeDownloadtips4": "pag-download ng android",
        "keep": "Panatilihin",
        "saveQr": "I-save ang QR code",
        "payPal": "Paypal",
        "coinBlock": "kasunduan sa pera",
        "validatorRequire": "Hindi maaaring walang laman ang mga kinakailangang field",
        "edit": "i-edit",
        "markDefaultAddress": "Markahan bilang default na address sa pagpapadala",
        "不能为空": "Hindi maaaring walang laman",
        "cancelOrder2": "ayoko, ayoko",
        "contactUs1": "Kung ayaw mong humiram ng pera sa mga kaklase at kaibigan, mangyaring makipag-ugnayan sa amin.",
        "": "",
        "不在交易时段": "wala sa oras ng pangangalakal",
        "不在可提现时间内": "Hindi sa loob ng withdrawal time",
        "paramError": "Error sa parameter",
        "参数错误": "Error sa parameter",
        "参数异常，消息获取失败": "Pagbubukod ng parameter, nabigo ang pagkuha ng mensahe",
        "Operate": "gumana",
        "operationSuccess": "Matagumpay na operasyon",
        "操作成功": "Matagumpay na operasyon",
        "操作类型不能小于0": "Ang uri ng operasyon ay hindi maaaring mas mababa sa 0",
        "操作类型不是整数": "ang uri ng operasyon ay hindi integer",
        "操作类型为空": "Walang laman ang uri ng operasyon",
        "view": "Suriin",
        "Checkorder": "suriin ang order",
        "logistics": "suriin ang logistik",
        "CheckDetails": "suriin ang mga detalye",
        "lowOpinion": "Masamang pagsusuri",
        "产品不存在": "wala ang produkto",
        "产品剩余数量不足": "Ang natitirang dami ng produkto ay hindi sapat",
        "interest": "makabuo ng interes",
        "dealSuccess": "tagumpay",
        "successTips": "tagumpay",
        "beSeller": "maging isang mangangalakal",
        "homeBannertips1": "maging isang mangangalakal",
        "承兑商不存在": "Ang Acceptor ay wala",
        "orderCity": "lungsod",
        "city": "lungsod",
        "程序错误": "error sa programa",
        "持有币种不足": "Hindi sapat na mga hawak ng pera",
        "recharge": "muling magkarga",
        "rechargeSuccessful": "Matagumpay na mag-recharge",
        "rechargeAddress": "Recharge address",
        "rechargeMethod": "Paraan ng pag-recharge",
        "rechargeRecord": "Recharge record",
        "充值价值不得大于最大限额": "Ang halaga ng top-up ay hindi maaaring lumampas sa maximum na limitasyon",
        "充值价值不得小于最小限额": "Ang halaga ng top-up ay hindi dapat mas mababa sa minimum na limitasyon",
        "充值链错误": "Error sa recharge chain",
        "rechargeNum": "Recharge na halaga",
        "充值数量不能小于等于0": "Ang halaga ng recharge ay hindi maaaring mas mababa sa o katumbas ng 0",
        "rechargeTips": "\"Paalala ng recharge: \"\"Mangyaring punan nang totoo ang aktwal na halaga ng paglilipat, kung hindi, maaari itong maging sanhi ng pagkabigo ng system sa pagsusuri at makaapekto sa pag-usad ng recharge.\"",
        "dealing": "Pinoproseso",
        "processing": "Pinoproseso",
        "ship": "Bangka",
        "creditText1": "Pautang sa negosyo upang malutas ang problema ng paghiram ng pera",
        "businessloan": "Ang aplikasyon ng pautang sa negosyo upang punan",
        "存在不同杠杆的持仓单": "May mga position order na may iba't ibang leverage",
        "cancelOrder7": "May mga problema sa kalidad",
        "存在重复的角色名称": "May mga duplicate na pangalan ng tungkulin",
        "大于最大采购数量": "Higit sa maximum na dami ng pagbili",
        "代理层级错误": "Error sa antas ng proxy",
        "delivered": "ihahatid",
        "pendingPayment": "Nakabinbing bayad",
        "待付款的订单无法放行": "Hindi mailalabas ang order na nakabinbing bayad",
        "comment": "Masusuri",
        "receipt": "Upang matanggap",
        "pending": "Para mabayaran",
        "loanHistory": "kasaysayan ng pautang",
        "rates": "Mga rate ng pagpapautang",
        "term": "termino ng pautang",
        "application": "aplikasyon ng pautang",
        "creditWorry": "Walang pag-aalala na pautang",
        "orderUnitprice": "presyo ng isang piraso",
        "当前地址格式错误": "Ang kasalukuyang address ay nasa maling format",
        "当前订单不为待付款状态，无法取消": "Ang kasalukuyang order ay hindi nakabinbing pagbabayad at hindi maaaring kanselahin",
        "当前还需交易": "Kailangan pang mag-trade",
        "currentRate": "kasalukuyang halaga ng palitan",
        "sure": "tiyak",
        "当日才可申购": "Available lang para bilhin sa parehong araw",
        "当日可提现次数不足": "Hindi sapat na bilang ng mga cash withdrawal bawat araw",
        "receivedAddress": "Address ng pagdating",
        "orderAddress": "address",
        "登陆密码不符合设定": "Ang login password ay hindi tumutugma sa mga setting",
        "登陆密码长度不符合设定": "Ang haba ng login password ay hindi nakakatugon sa mga setting",
        "login": "Mag log in",
        "loginIn": "Mag log in",
        "signIn": "Mag log in",
        "loginSuccess": "matagumpay ang pag-log in",
        "登录过期，请重新登录": "Nag-expire ang pag-login, mangyaring mag-log in muli",
        "LoginPassword": "password sa pag-login",
        "登录密码必须6-12位": "Dapat na 6-12 character ang login password",
        "登录密码不能为空": "Hindi maaaring walang laman ang password sa pag-login",
        "登录失败": "Hindi tagumpay ang pag-login",
        "clickUpload": "I-click para mag-upload",
        "phoneNumber": "numero ng telepono",
        "电话号码已绑定": "Ang numero ng telepono ay nakatali",
        "电话号码已绑定其他用户": "Ang numero ng telepono ay nakatali sa ibang user",
        "email": "e-mail",
        "shopCollection": "koleksyon ng tindahan",
        "trackOrder": "Umorder",
        "订单不存在": "walang order",
        "orderTrack": "Pagsubaybay sa Order",
        "serialNumber": "numero ng order",
        "orderSummary": "Buod ng order",
        "cancelOrderSuccess": "Matagumpay na nakansela ang order",
        "orderDetails": "mga detalye ng order",
        "orderInfo": "impormasyon ng order",
        "订单已取消": "nakansela ang order",
        "订单已取消，无法放行": "Ang order ay kinansela at hindi maaaring ilabas",
        "订单已完成，无法放行": "Nakumpleto na ang order at hindi na mailalabas",
        "moneyOrderStatus": "Katayuan ng Order",
        "orderPrefix": "kabuuang order",
        "subscription": "mag-subscribe",
        "aboutText2": "Halaga: 100,000 hanggang 30,000,000, mababang interes, flexible na paraan ng pagbabayad, walang paunang bayad, online na pagpapautang, walang mga tawag sa pagsusuri, pagiging kumpidensyal ng impormasyon, at pautang sa parehong araw.",
        "additional": "karagdagang",
        "evaluateOrderSuccess": "Matagumpay na mag-post ng komento",
        "goodsShip": "barko",
        "send": "ipadala",
        "发现新版本，请升级到最新版本": "May nakitang bagong bersyon, mangyaring mag-upgrade sa pinakabagong bersyon",
        "visitStore": "bisitahin ang tindahan",
        "collAccount": "Paraan ng pautang",
        "loanMethod": "Paraan ng pautang",
        "classification": "Pag-uuri",
        "服务器错误": "Error sa Server",
        "服务器错误(500)": "error sa server (500)",
        "servicePolicy": "Patakaran sa Serbisyo",
        "PaymentOrder": "Resibo",
        "uploadTips": "Katibayan ng pagbabayad (mag-upload ng screenshot ng mga detalye ng pagbabayad)",
        "copy": "kopya",
        "copySuccess": "matagumpay na kopyahin",
        "该产品未上架": "Hindi available ang produktong ito",
        "该产品已上市，无法购买": "Nakalista na ang produktong ito at hindi mabibili",
        "该订单已取消": "Kinansela ang order na ito",
        "remindRepeat": "Ang utos ay pinaalalahanan~",
        "该广告剩余数量不足": "Walang sapat na natitirang mga ad para sa ad na ito",
        "该基金尚未开放购买": "Ang pondo ay hindi pa bukas para sa pagbili",
        "该基金尚已封闭": "Ang pondo ay sarado",
        "productAvailable": "Hindi na available ang produktong ito",
        "该邮箱已被订阅": "Ang mailbox na ito ay naka-subscribe",
        "notOpen": "Ang paraan ng pagbabayad na ito ay hindi pa available sa iyong rehiyon",
        "格式有误:充值金额不能小于1(包含俩位小数)": "Mali ang format: ang halaga ng recharge ay hindi maaaring mas mababa sa 1 (kabilang ang dalawang decimal na lugar)",
        "userCenter": "personal na sentro",
        "Item": "mga bagay",
        "跟单倍数输入错误": "Documentation maramihang input error",
        "跟单参数输入错误": "Kopyahin ang error sa input ng parameter",
        "more": "Higit pa",
        "更新提醒": "i-update ang paalala",
        "工作地址不能为空": "Hindi maaaring walang laman ang address ng trabaho",
        "homeBannertips2": "magbahagi ng komisyon",
        "orderTotal": "Kabuuan",
        "buyHistory": "Kasaysayan ng Pagbili",
        "购买矿机时间不得低于托管订单剩余时间": "Ang oras para bumili ng mga mining machine ay hindi dapat mas mababa sa natitirang oras ng hosting order",
        "purchageHistory": "kasaysayan ng pagbili",
        "addCartMessageFaild": "Ang produkto ay mayroon na sa shopping cart",
        "fixedRate": "nakapirming rate",
        "aboutUs": "tungkol sa atin",
        "about": "tungkol sa atin",
        "followers": "tumutok sa",
        "followedSuccess": "Sinundan",
        "myFollowedShops": "Sundin ang tindahan",
        "广告不存在": "Walang ad",
        "广告已下架": "Inalis ang ad",
        "orderSpecification": "Pagtutukoy",
        "countryOf": "Bansa ng pagkamamamayan",
        "areaCode": "International area code",
        "orderNation": "bansa",
        "nation": "bansa",
        "repayment": "pagbabayad",
        "repay": "Pagbabayad",
        "reAmount": "Halaga ng Pagbabayad",
        "cycle": "cycle ng pagbabayad",
        "loginTips": "Wala ka pang account?",
        "noAccount": "Wala ka pang account?",
        "NoProductSelected": "Wala pang napiling produkto",
        "shipping": "Pagpapadala",
        "highOpinion": "papuri",
        "favorableRate": "paborableng rate",
        "myPraiseRate": "paborableng rate",
        "totalNum": "kabuuan",
        "partner": "Tagatustos ng kooperasyon",
        "partnersTit": "Partners - Online Lending Platform",
        "BackHome": "bumalik sa homepage",
        "or": "o",
        "freight": "kargamento",
        "orderFreight": "kargamento",
        "getCoupons": "Kumuha ng higit pang mga kupon para sa iyo",
        "基金剩余购买金额不足": "Hindi sapat na pondo ang natitirang halaga ng pagbili",
        "quickLoan": "mabilis na pautang",
        "records": "Itala",
        "proceed": "magpatuloy",
        "storeSeachTips3": "Bahay",
        "家庭地址不能为空": "Hindi maaaring walang laman ang address ng tahanan",
        "cancelOrder4": "pekeng tatak",
        "price": "presyo",
        "piece": "mga piraso",
        "transactionPassword": "password ng transaksyon",
        "交易员不存在": "ang mangangalakal ay wala",
        "交易员不能跟随自己": "hindi maaaring sundin ng mga mangangalakal ang kanilang sarili",
        "交易员跟随人数已满": "Ang bilang ng mga mangangalakal na sumusunod ay puno na",
        "交易员未开启带单": "Hindi pa binuksan ng negosyante ang order",
        "交易员无法跟随另一个交易员": "Ang isang mangangalakal ay hindi maaaring sumunod sa isa pang mangangalakal",
        "角色被用户关联，不可删除": "Ang tungkulin ay nauugnay sa user at hindi matatanggal",
        "角色不存在": "ang papel ay wala",
        "receiver": "receiver",
        "financial": "Lutasin ang iyong mga problema sa pananalapi",
        "successLoan": "matagumpay na pautang",
        "borrow": "Kabiguan sa paghiram",
        "loanAgree": "kasunduan sa pautang",
        "amount": "ang halaga",
        "金额不在购买区间": "Ang halaga ay wala sa hanay ng pagbili",
        "validatorMaxNumber": "Lampas sa limitasyon ang halaga",
        "金额错误": "maling halaga",
        "validatorChineseAndEnglish": "Tanging Chinese at English ang sinusuportahan, at ang input range ay 8-64 character",
        "oldPassword": "Lumang password",
        "旧密码不能为空": "Hindi maaaring walang laman ang lumang password",
        "旧密码不正确": "Ang lumang password ay hindi tama",
        "可平仓合约张数不足": "Hindi sapat na bilang ng mga liquidable na kontrata",
        "service": "serbisyo sa customer",
        "custService": "serbisyo sa customer",
        "homeDownloadtips1": "Cross-border e-commerce wholesale shopping mall",
        "电商批发商场": "E-commerce wholesale shopping mall",
        "矿机不存在": "Ang minero ay wala",
        "矿机未解锁，无法购买": "Ang makina ng pagmimina ay hindi naka-unlock at hindi mabibili",
        "From": "mula sa",
        "历史基金无法购买": "Hindi mabibili ang mga makasaysayang pondo",
        "historySearch": "Paghahanap sa kasaysayan",
        "payment": "Agad na pagbabayad",
        "buyNow": "Bilhin mo na",
        "homeBannerbtn": "Sumali ka na",
        "evaluate": "Suriin ngayon",
        "连续输入错误三次，请3分钟后再试": "Maling naipasok nang tatlong beses na magkakasunod, pakisubukang muli sa loob ng 3 minuto",
        "contactUs": "Makipag-ugnayan sa amin",
        "twoPawword": "hindi magkatugma ang dalawang password",
        "creditQuota": "Flexible na quota",
        "retailPrice": "presyong tingi",
        "领取成功": "Tumanggap ng tagumpay",
        "pageviews": "Mga view",
        "myPageviews": "Mga view",
        "buyRules": "tuntunin ng mamimili",
        "买入金额需要在区间内": "Ang halaga ng pagbili ay kailangang nasa saklaw",
        "卖方无法取消该订单": "Hindi maaaring kanselahin ng nagbebenta ang order",
        "cancelOrder3": "Ang nagbebenta ay nagpadala ng maling item",
        "sellerRules": "patakaran ng nagbebenta",
        "noDataFound": "walang nakitang data",
        "没有找到用户": "walang nahanap na user",
        "dailyNewArrival": "Araw-araw na Bagong Pagdating",
        "password": "password",
        "密码必须6-12位": "Ang password ay dapat na 6-12 character",
        "密码不能为空": "hindi maaaring blangko ang password",
        "密码不正确": "Maling password",
        "wrongPassword": "Ang bilang ng mga maling password ay lumampas sa 3 beses, pakisubukang muli bukas",
        "validatorPassword": "Ang password ay binubuo ng 6-12 digit o titik (kabilang ang mga espesyal na character)",
        "goodsFreeShipping": "libreng pagpapadala",
        "orderName": "pangalan",
        "defaultAddress": "default na address",
        "noCartTips": "Walang laman ang iyong shopping bag simulan ang pamimili",
        "notLogin": "Hindi ka naka-login",
        "unSelectedProduct": "Hindi mo napili ang produkto",
        "evaluationUploading": "Mayroon ka pa ring mga larawang ina-upload, pakisubukang muli sa ibang pagkakataon",
        "您当前可分配额度不足": "Ang iyong kasalukuyang alokasyon ay hindi sapat",
        "yourEmail": "ang email mo",
        "您没有符合条件的收款方式": "Wala kang karapat-dapat na paraan ng pagbabayad",
        "您已存在订单": "May order ka na",
        "您已购买过体验矿机,不得重复购买": "Nakabili ka na ng karanasan sa pagmimina at hindi na makakabili muli",
        "photoExample": "Halimbawa ng larawan",
        "homeDownloadtips2": "tatak sa pagbebenta",
        "Evaluate": "suriin",
        "evaluateOrder": "Suriin ang listahan",
        "evaluateInput": "Magkomento sa larawan",
        "homeDownloadtips5": "pag-download ng mansanas",
        "cancelOrder9": "iba pang mga dahilan",
        "businessPhone": "telepono ng negosyo",
        "businessEmail": "mailbox ng enterprise",
        "walletHistory": "kasaysayan ng wallet",
        "亲属地址不能为空": "Hindi maaaring walang laman ang kaugnay na address",
        "亲属电话不能为空": "Hindi maaaring walang laman ang kaugnay na numero ng telepono",
        "亲属关系不能为空": "Hindi maaaring walang laman ang relasyon",
        "亲属姓名不能为空": "Hindi maaaring walang laman ang kaugnay na pangalan",
        "empty": "walang laman",
        "evaluateOrderPlaceholder": "Paki-rate ang produkto",
        "checkAgreement": "Pakisuri ang kasunduan!",
        "请检查网络连接": "Pakisuri ang koneksyon sa network",
        "returnDetailTips": "Paki-rate ang produkto",
        "switchLang": "Mangyaring lumipat sa ibang mga wika upang tingnan",
        "请切换其他语言后查看": "Mangyaring lumipat sa ibang mga wika upang tingnan",
        "请上传图片": "Mangyaring mag-upload ng isang larawan",
        "uploadPhoto": "Mangyaring mag-upload ng larawan",
        "请稍后再试": "Subukang muli mamaya",
        "请稍后重试": "Subukang muli mamaya",
        "pleaseSetLoginPassword": "Mangyaring magtakda ng password sa pag-login",
        "pleaseSetMobileNumber": "Mangyaring magtakda ng numero ng mobile",
        "pleaseEnterPhoneNumer": "Mangyaring magtakda ng numero ng mobile",
        "plaeseEnterInvitaionCode": "Mangyaring magtakda ng code ng imbitasyon",
        "pleaseEnterEmail": "Mangyaring mag-set up ng email",
        "enterTips": "pasok",
        "pleaseInput": "pasok",
        "validatorFourMoreNumber": "Mangyaring maglagay ng higit sa 4 na purong numero",
        "pleaseValidPostCode": "Mangyaring magpasok ng higit sa 4 na numero",
        "validatorSixNumber": "Mangyaring maglagay ng 6 na purong numero",
        "请输入充值币种": "Mangyaring ilagay ang recharge na pera",
        "plaseEnterRechargeAddress": "Pakilagay ang recharge address",
        "pleaseEnterAmount": "Pakilagay ang halaga ng recharge",
        "pleaseInputCorrectNumber": "Mangyaring magpasok ng numerong higit sa 0",
        "pleaseEnterAddress": "pakilagay ang address",
        "headerSearchTips": "Mangyaring magpasok ng mga keyword na hahanapin",
        "pleaseEnterOldPassword": "Pakipasok ang lumang password",
        "pleaseEnterPassword": "pakilagay ang password",
        "请输入内容": "Mangyaring magpasok ng nilalaman",
        "plaseeENterConfirmPassword": "Mangyaring ipasok ang password sa pagkumpirma",
        "pleaseEnterQuantity": "Pakilagay ang dami",
        "请输入搜索关键字": "Mangyaring ipasok ang iyong mga keyword sa paghahanap",
        "withdrawInputTips": "Pakilagay ang withdrawal address",
        "plaseeEnterNewPassword": "Mangyaring magpasok ng bagong password",
        "yourName": "Paki-type ang iyong pangalan",
        "pleaseEnterAccount": "Mangyaring ipasok ang Username",
        "请输入正确的货币数量": "Pakipasok ang tamang halaga ng pera",
        "请输入正确的金额": "Pakilagay ang tamang halaga",
        "validatorPhone": "mangyaring magpasok ng wastong numero ng telepono",
        "pleaseValidPhone": "Pakilagay ang tamang numero ng telepono",
        "请输入正确的数量": "Pakilagay ang tamang dami",
        "inpuEmailErro": "Mangyaring ilagay ang tamang email address",
        "pleaseValidEmail": "Mangyaring ilagay ang tamang email address",
        "validatorEmail": "Mangyaring ilagay ang tamang format ng email",
        "请输入正确的质押金额": "Pakilagay ang tamang halaga ng pledge",
        "请输入正确的质押天数": "Pakilagay ang tamang mga araw ng pledge",
        "pleaseCorrectAddress": "Pakilagay ang tamang withdrawal address",
        "请填写正确的电话号码": "Mangyaring punan ang tamang numero ng telepono",
        "请填写正确的验证码": "Pakipasok ang tamang verification code",
        "mailboxCheck": "Mangyaring punan ang tamang email address",
        "请填写正确的邮箱地址": "Mangyaring punan ang tamang email address",
        "请先绑定谷歌验证器": "Pakibigkis muna ang Google Authenticator",
        "请先添加收款方式": "Mangyaring magdagdag muna ng paraan ng pagbabayad",
        "请先通过高级认证": "Mangyaring ipasa muna ang advanced na sertipikasyon",
        "cancelOrderTitle": "Mangyaring pumili ng dahilan para sa pagkansela ng order",
        "selectCountry": "Mangyaring pumili ng nasyonalidad",
        "请选择买卖方式": "Mangyaring pumili ng paraan ng pangangalakal",
        "selectPeriod": "Mangyaring pumili ng panahon",
        "returnOrderTitle": "Mangyaring pumili ng dahilan para sa pagbabalik",
        "请选择正确的币种": "Mangyaring piliin ang tamang pera",
        "请重新登录": "mangyaring mag-login muli",
        "blockchainNetwork": "network ng blockchain",
        "渠道未开通": "hindi bukas ang channel",
        "Cancel": "Kanselahin",
        "取消": "Kanselahin",
        "cancelSuccess": "Kanselahin ang tagumpay",
        "cancelOrder": "kanselahin ang order",
        "cancel": "Kanselahin",
        "CancelOrder": "kanselahin ang order",
        "myUnfollow": "mag-unsubscribe",
        "cancelReason": "Dahilan ng Pagkansela",
        "all": "lahat",
        "AllProducts": "lahat ng produkto",
        "btnSure": "Oo naman",
        "确认": "kumpirmahin",
        "entRepay": "Kumpirmahin ang pagbabayad",
        "confirmPayPaw": "Kumpirmahin ang password ng transaksyon",
        "confirmPassword": "Kumpirmahin ang Password",
        "delAllHistoryRecord": "Sigurado ka bang tatanggalin ang lahat ng kasaysayan?",
        "confirm": "kumpirmahin ang pagtanggap ng mga kalakal",
        "date": "petsa",
        "scanAndDown": "I-scan ang QR code para mag-download ng APP",
        "homeDownloadtips6": "I-scan ang QR code para i-download ang APP",
        "delete": "tanggalin",
        "sellerPanelLogin": "Login ng merchant",
        "merchantSettled": "Pumasok ang mga mangangalakal",
        "sellerZone": "maging isang mangangalakal",
        "commodity": "kalakal",
        "orderCommodity": "kalakal",
        "commodityCollection": "Koleksyon ng mga kalakal",
        "productDescription": "paglalarawan ng produkto",
        "myCommodityCollection": "Koleksyon ng produkto",
        "goodsNumber": "Bilang ng mga Produkto",
        "goodsShipTips": "Pagkatapos ma-order ang produkto, ipapadala ito sa loob ng 24 na oras. Ang mga sumusunod na order ay may kontrol sa logistik, at ang order ay maaaring maantala sa paghahatid. Mangyaring bigyang pansin ang impormasyon ng logistik ng order o makipag-ugnayan sa customer service",
        "productInfo": "impormasyon ng produkto",
        "uploadSuccess": "matagumpay na na-upload",
        "uploadError": "Nabigo ang pag-upload, pakisubukang muli",
        "uploading": "ina-upload.....",
        "upNew": "pinakabago",
        "previous": "Nakaraang",
        "prevPage": "Nakaraang pahina",
        "cancelOrder5": "kulang ang buhok, kulang ang buhok",
        "desc": "itakda bilang default na address",
        "setAsTheDefaultAddress": "itakda bilang default na address",
        "setUp": "set up",
        "setSuccess": "matagumpay na naitakda",
        "setUpPayPaw": "Itakda ang password ng transaksyon",
        "setPassword": "itakda ang password",
        "申购数量错误": "Error sa dami ng pagbili",
        "申请成功": "matagumpay na aplikasyon",
        "applyLoan": "mag-aplay para sa isang pautang",
        "applicationAmount": "Halaga ng Application",
        "noSmaller": "Ang halaga ng aplikasyon ay hindi maaaring mas mababa sa",
        "nomax": "Ang maximum na halaga ng aplikasyon ay hindi maaaring lumampas",
        "applicant": "aplikante",
        "applicantDate": "Petsa ng Application",
        "return": "Aplikasyon para sa pagbabalik",
        "applicantIn": "sa aplikasyon",
        "身份证已实名过!": "Na-verify na ang ID card!",
        "审核已通过": "Pasado ang audit",
        "审核中": "nasa ilalim ng pagsusuri",
        "state": "Lalawigan/Estado/Estado",
        "dealFail": "mabibigo",
        "fail": "mabibigo",
        "orderTime": "oras",
        "time": "oras",
        "ActualLedger": "Aktwal na account",
        "actualAccount": "totoong account",
        "实名认证未通过，无法进行高级认证": "Nabigo ang real-name authentication, hindi nagawang magsagawa ng advanced na authentication",
        "confirmReceiveGoods": "Kung kumpirmahin ang pagtanggap ng mga kalakal",
        "collect": "mangolekta",
        "collectionSuccess": "Tagumpay sa koleksyon",
        "wishlist": "Paboritong Produkto",
        "cancelOrder6": "Nakatanggap ng nasirang produkto",
        "desc5": "Maling address sa pagpapadala? kumonekta",
        "consigneeName": "Pangalan ng consignee",
        "shippingAddress": "Address ng tatanggap",
        "pleaseAddShippingAddress": "Mangyaring magdagdag muna ng address sa pagpapadala",
        "收款方输入错误": "Error sa pag-input ng nagbabayad",
        "mobile": "Numero ng telepono",
        '购物车还没有商品': "Walang laman ang iyong shopping cart",
        '去购物': "Pumunta sa pamimili",
        "mobilePhone": "numero ng telepono",
        "handleFee": "handling fee",
        "handlingFee": "handling fee",
        "home": "unang pahina",
        "授权状态未成功": "Nabigo ang Katayuan ng Pagpapahintulot",
        "pleaseSetAreaCode": "Ilagay ang country at area code para maghanap",
        "searchCountry": "Ilagay ang country at area code para maghanap",
        "desc3": "Ipasok ang password ng transaksyon",
        "desc4": "Ilagay ang password ng iyong transaksyon",
        "赎回状态异常": "Abnormal na katayuan sa pagtubos",
        "quantity": "dami",
        "orderAmount": "dami",
        "orderQuantity": "dami",
        "inputNum": "numero",
        "orderTax": "Buwis",
        "orderFee": "buwis",
        "tax": "ang buwis",
        "delivery": "Paghahatid at Pagkuha",
        "storeSeach": "Maghanap sa aming tindahan",
        "search": "paghahanap",
        "所选汇率不存在": "Ang napiling halaga ng palitan ay hindi umiiral",
        "allProduct": "Lahat ng produkto",
        "提币数量不能小于等于0": "Ang halaga ng pag-withdraw ay hindi maaaring mas mababa sa o katumbas ng 0",
        "creditText2": "Magbigay ng serbisyo sa paglilipat ng kapital ng pautang sa negosyo",
        "returnOrderSuccess": "Matagumpay na naisumite",
        "Submitareview": "magsumite ng mga komento",
        "submitApplica": "magsumite ng aplikasyon",
        "提交失败": "Nabigo ang pagsusumite",
        "提交失败，当前有未处理订单": "Nabigo ang pagsusumite, may kasalukuyang hindi naprosesong mga order",
        "hint": "pahiwatig",
        "提示": "pahiwatig",
        "withdraw": "bawiin",
        "提现不得大于限额": "Ang pag-withdraw ay hindi maaaring lumampas sa limitasyon",
        "提现不得小于限额": "Ang pag-withdraw ay hindi dapat mas mababa sa limitasyon",
        "withdrawSuccess": "Matagumpay na naisumite ang mga order",
        "withdrawAddress": "Address ng pag-withdraw",
        "withdrawRecord": "Talaan ng mga withdrawal",
        "withdrawNum": "Kalakihan ng kinuha",
        "tipsRemindsSuccess": "tagumpay ng paalala",
        "remindSuccess": "tagumpay ng paalala",
        "RemindShip": "Paalalahanan ang mga mangangalakal ng paghahatid",
        "remind": "Paalalahanan ang mga mangangalakal ng paghahatid",
        "remindTitle": "Paalalahanan ang mga mangangalakal ng paghahatid",
        "tipsRemindsText": "Paalala Kapag naipadala na ang kargamento, makakatanggap ng paalala ang merchant",
        "remindContent": "Pagkatapos maipadala ang paalala, makakatanggap ng paalala ang merchant, at isang beses lang itong mapaalalahanan~",
        "tipsRemindsMerchant": "Paalalahanan ang mga mangangalakal",
        "days": "langit",
        "addCartMessage": "Matagumpay na naidagdag sa cart",
        "addAddress": "magdagdag ng address",
        "addAddressOrModifyAddress": "Magdagdag ng Address/Baguhin ang Address",
        "addCart": "idagdag sa cart",
        "图片不得大于10M": "Ang larawan ay hindi dapat mas malaki sa 10M",
        "图片不得大于2M": "Ang larawan ay hindi dapat mas malaki sa 2M",
        "图片大小不能超过2M！": "Ang laki ng larawan ay hindi maaaring lumampas sa 2M!",
        "图片上传失败": "Nabigo ang pag-upload ng larawan",
        "recommend": "magrekomenda",
        "recommendedProducts": "Mga Inirerekomendang Produkto",
        "recommendedStore": "Inirerekomenda na tindahan",
        "推荐码不正确": "Mali ang referral code",
        "推荐人无权限推荐": "Ang nagrerekomenda ay walang awtoridad na magrekomenda",
        "推荐商品": "inirerekomendang produkto",
        "logout": "huminto",
        "returnsAndEx": "Mga Pagbabalik at Pagpapalit",
        "returnAmount": "halaga ng pagbabalik",
        "returnRemark": "ibalik ang mga tagubilin",
        "returnPolicy": "Patakaran sa Pag sauli",
        "Refund": "Refund",
        "refund": "Refund/After-sale",
        "refundSuccessfully": "Matagumpay na mag-refund",
        "refundSuccess": "Matagumpay na mag-refund",
        "returnReason": "Dahilan para sa refund",
        "returnApply": "aplikasyon ng refund",
        "refundFail": "Nabigo ang refund",
        "refundInstructions": "Mga tagubilin sa refund",
        "refunding": "Pag-refund",
        "mastercard": "MasterCard",
        "EsShop": "online na tindahan",
        "ForgotPassword": "nakalimutan ang password?",
        "委托数量(张)必填": "Pinagkatiwalaang Dami (Mga Piraso) Kinakailangan",
        "委托数量(张)不能小于等于0": "Ang bilang ng mga komisyon (mga piraso) ay hindi maaaring mas mababa sa o katumbas ng 0",
        "foryourmoney": "Para malutas mo ang mga problema sa pautang tulad ng masikip na pondo, walang makahiram ng pera, kahihiyan na humiram ng pera mula sa mga kaibigan, atbp., mga serbisyong propesyonal sa buong proseso, pagsagot sa iyong mga pagdududa at palaisipan anumang oras, ang aming layunin ay gawing transparent ang bawat pautang, upang magamit ito ng mga customer nang mabilis at ligtas.",
        "storeSeachTips1": "natagpuan para sa iyo",
        "未绑定谷歌验证器": "Unbound Google Authenticator",
        "未绑定手机号": "Hindi nakatali na numero ng mobile phone",
        "未绑定邮箱": "Hindi nakatali na mailbox",
        "未发现授权记录": "Hindi nakita ang rekord ng pahintulot",
        "notQua": "Hindi naabot ang mga kwalipikasyon",
        "ShippingAddressNotSet": "Hindi itinakda ang address ng pagpapadala",
        "未实名认证，是否认证？": "Walang real-name authentication, gusto mo bang magpa-authenticate?",
        "cancelOrder1": "Hindi namin natanggap ang mga kalakal",
        "未授权访问": "hindi awtorisadong pag-access",
        "noRefund": "walang refund",
        "未找到符合条件的匹配订单": "Walang nakitang katugmang order",
        "未找到匹配的收益记录": "Walang nakitang katugmang tala ng kita",
        "mine": "akin",
        "myloan": "ang aking utang",
        "myOrder": "Aking Order",
        "myCart": "ang shopping cart ko",
        "我的购物车": "ang shopping cart ko",
        "myPurse": "Ang pitaka ko",
        "myAccount": "aking Account",
        "aboutText1": "\"Kami ay nakatuon sa pagpapautang ng mga serbisyong pinansyal, batay sa pilosopiya ng negosyo ng \"\"customer first\"\", na may misyon na lutasin ang mga problema sa capital turnover ng mga customer. Mula nang itatag ito, tinulungan ng kumpanya ang hindi mabilang na natitirang mga customer na malutas ang kanilang mga problema sa capital turnover.\"",
        "readAndAgree": "Nabasa ko at sumasang-ayon ako",
        "safeInfo": "Mga hindi secure na pautang, walang kinakailangang deposito, walang return call, ito ay isang pribadong bagay.",
        "无权限": "Walang pahintulot",
        "无效的UID": "di-wastong UID",
        "item": "bagay",
        "系统参数错误": "Error sa parameter ng system",
        "系统存在相同[系统登录名]！": "Ang system ay umiiral na may parehong [system login name]!",
        "系统错误，请稍后重试": "Error sa system, pakisubukang muli sa ibang pagkakataon",
        "defaultRate": "Default na papuri ng system",
        "checkout": "umorder",
        "下单不能小于最小金额限制": "Ang order ay hindi maaaring mas mababa sa minimum na limitasyon sa halaga",
        "buyTips": "Pagkatapos ilagay ang order, ipapadala ito sa loob ng 24 na oras. Ang mga sumusunod na order ay napapailalim sa kontrol ng logistik at maaaring maantala sa paghahatid. Mangyaring bigyang pansin ang impormasyon sa logistik o makipag-ugnayan sa serbisyo sa customer.",
        "nextPage": "Susunod na pahina",
        "stateMent": "Modernong Pahayag ng Pang-aalipin",
        "storeSeachTips2": "kaugnay na tindahan",
        "address": "Address",
        "items": "proyekto",
        "browse": "Benta",
        "sold": "dami ng benta",
        "sales": "dami ng benta",
        "校验IP不合法": "Di-wasto ang verification IP",
        "new": "bago",
        "newPassword": "Bagong Password",
        "新密码不能为空": "Hindi maaaring walang laman ang bagong password",
        "新密码不一致": "Hindi tugma ang bagong password",
        "新密码确认不能为空": "Hindi maaaring walang laman ang bagong kumpirmasyon ng password",
        "news": "balita",
        "addNewAddress": "magdagdag ng address",
        "creditTit": "serbisyo ng kredito",
        "Information": "impormasyon",
        "行情获取异常，稍后再试": "Mga abnormal na kundisyon ng market, subukang muli sa ibang pagkakataon",
        "modifyAddress": "Baguhin ang address",
        "handlingfee": "Kailangan ng bayad",
        "Opt": "pumili",
        "selectDeliveryAddress": "piliin ang address ng pagpapadala",
        "验证类型不能为空": "Ang uri ng pagpapatunay ay hindi maaaring walang laman",
        "验证码不能为空": "dapat punan ang verification code",
        "验证码不正确": "Maling verification code",
        "验证码错误": "Error sa verification code",
        "vcodeFail": "Nabigo ang pag-verify, pakisubukang muli",
        "vcodePass": "Lumipas ang pag-verify!",
        "invitationCode": "Code ng imbitasyon",
        "页码不能小于等于0": "Ang numero ng pahina ay hindi maaaring mas mababa sa o katumbas ng 0",
        "页码不是整数": "Ang numero ng pahina ay hindi isang integer",
        "dashboard": "Dashboard",
        "loaned": "Pinahiram",
        "loanDays": "Mga araw ng pautang",
        "followed": "Sinundan",
        "repaid": "binayaran",
        "已领取": "natanggap",
        "rated": "na-rate",
        "cancelled": "Kinansela",
        "confirmed": "nakumpirma",
        "harvested": "natanggap",
        "mySold": "naibenta",
        "overdue": "overdue na",
        "privacyPolicy": "Patakaran sa Privacy",
        "用户不存在": "Walang gumagamit",
        "用户名必须由数字和英文字母组成": "Ang username ay dapat na binubuo ng mga numero at English na titik",
        "用户名不存在": "Ang username ay wala",
        "用户名不符合设定": "Ang username ay hindi nakakatugon sa mga kinakailangan",
        "用户名不能为空": "Hindi maaaring walang laman ang username",
        "用户名参数为空": "Walang laman ang parameter ng username",
        "用户名重复": "duplicate na username",
        "userEvaluation": "pagsusuri ng gumagamit",
        "用户剩余数量不足": "Hindi sapat na bilang ng mga natitirang user",
        "用户已跟随交易员": "Sinundan ng user ang isang negosyante",
        "user_Center": "User Center",
        "userReg": "pagpaparehistro ng gumagamit",
        "postCode": "post code",
        "orderEmail": "Mail",
        "邮箱已绑定": "Nakatali ang email",
        "邮箱已绑定其他用户": "Ang mailbox ay nakatali sa ibang user",
        "orderPostCode": "zip code",
        "hasImage": "May mga larawan",
        "Balance": "balanse",
        "balance": "Balanse (USDT)",
        "余额不足": "Hindi sapat na balanse",
        "balanceNot": "Hindi sapat na balanse, mangyaring mag-recharge",
        "cancelOrder8": "Makipag-ayos sa merchant para sa refund",
        "expectedArrival": "Tinatayang pagdating",
        "esRepayment": "Tinantyang pagbabayad",
        "estirepay": "Tinantyang pagbabayad",
        "originPrice": "orihinal na presyo",
        "deliveryFee": "kargamento",
        "goodsFreight": "kargamento",
        "shippingDiscounts": "diskwento sa pagpapadala",
        "homeIconTips3": "diskwento sa pagpapadala",
        "desc6": "Ilagay muli ang iyong password sa transaksyon",
        "rebuy": "isa pang order",
        "onlineService": "online na serbisyo",
        "customeService": "online na serbisyo",
        "helpLine": "online na serbisyo",
        "onlineApplin": "Online na Aplikasyon",
        "暂无店铺": "Wala pang tindahan",
        "noComments": "Wala pang komento",
        "noData": "Walang data",
        "帐户异常需要进行C3认证，请联系在线客服。": "Ang mga pagbubukod sa account ay nangangailangan ng pagpapatunay ng C3, mangyaring makipag-ugnayan sa online na serbisyo sa customer.",
        "account": "account",
        "accountBalance": "Balanse ng account",
        "accountB": "Balanse ng account",
        "accountReview": "Pangkalahatang-ideya ng account",
        "Recruitment": "Recruitment",
        "找不到用户": "hindi nahanap ang user",
        "searchTips": "Maghanap ng mga mapagkukunan / kalakal / supplier / pagbili",
        "discount": "diskwento",
        "homeDownloadtips3": "Walang tigil na mga diskwento",
        "discounted": "Mga produktong may diskwento",
        "actualName": "aktwal na pangalan",
        "passPortImg": "Numero ng Dokumento/Numero ng Pasaporte",
        "uploadId": "Pag-upload ng ID photo/passport",
        "Payment": "magbayad",
        "pay": "magbayad",
        "paymentSuccessful": "matagumpay ang transaksiyon",
        "paymentPending": "Nakatengga ang Pagbayad",
        "paymentPendingDesc": "Ang iyong pagbabayad ay napoproseso. Pakitingnan ang status ng iyong order mamaya",
        "paymentMethod": "paraan ng Pagbayad",
        "paymethods": "paraan ng Pagbayad",
        "payCertificate": "voucher sa pagbabayad",
        "直线关系，不能修改推荐": "Straight line na relasyon, hindi mababago Inirerekomenda",
        "tipsRemindsCount": "Minsan ko lang ipaalala sayo~",
        "committed": "Nakatuon sa Entrepreneur Loan Services",
        "mediumOpinion": "Katamtaman",
        "sort": "uri",
        "重复提交": "paulit-ulit na pagsusumite",
        "Reapply": "Mag-apply muli",
        "register": "magparehistro",
        "signUp": "magparehistro",
        "registerSuccess": "tagumpay sa pagpaparehistro",
        "转账币种不能为空": "Ang paglipat ng pera ay hindi maaaring walang laman",
        "转账数量不能小于等于0": "Ang halaga ng paglilipat ay hindi maaaring mas mababa sa o katumbas ng 0",
        "orderStatus": "estado",
        "orderState": "estado",
        "状态不能小于0": "Hindi maaaring mas mababa sa 0 ang katayuan",
        "状态不是整数": "ang status ay hindi isang integer",
        "资金密码必须6-12位": "Ang password ng pondo ay dapat na 6-12 digit",
        "资金密码不符合设定": "Ang password ng pondo ay hindi nakakatugon sa mga kinakailangan",
        "资金密码不能为空": "Hindi maaaring walang laman ang password ng pondo",
        "资金密码错误": "Error sa password ng pondo",
        "资金密码长度不符合设定": "Ang haba ng password ng pondo ay hindi nakakatugon sa mga kinakailangan",
        "complex": "komprehensibo",
        "totalOf": "kabuuan",
        "totalPrice": "kabuuang presyo",
        "homeBannertips3": "Pinakamataas",
        "creditReview": "Ang pinakamabilis na oras upang maipasa ang pagsusuri ay isang oras, at ang pagbabayad ay gagawin kaagad pagkatapos maipasa ang pagsusuri.",
        "yesterday": "kahapon",
        "binance": "Binance",
        "huobi": "Huobi",
        "validatorIpRule": "Mali ang format ng IP",
        "metaMask": "MetaMask",
        "footTip": "Copyright {name} Ltd 2024 Nakalaan ang lahat ng karapatan",
        "footTips": "Ang {name} Limited ay pinahintulutan at kinokontrol ng Financial Conduct Authority bilang isang credit broker (713206) at eksklusibong nakikipag-ugnayan sa nagpapahiram na Home Retail Group CardServices Limited bilang {name} Financial Services, na pinahintulutan at kinokontrol ng Financial Conduct Authority na magbigay ng credit (716148). Ang Home Retail GroupCard Services Limited ay nakarehistro sa Great Britain (04007072) kasama ang address nito sa Avebury, 489-499Avebury Boulevard, Milton Keynes, United Kingdom. MK9 2NW.",
        "footdec": "Ang mga gumagamit ng {name} Global Station ay nagmula sa {num} bansa sa buong mundo at gumagamit ng {coin} para sa settlement. Ang {coin} ay isang walang hangganang paraan ng transaksyon, na maaaring magkaroon ng mga instant na transaksyong mababa ang halaga sa pandaigdigang saklaw, nang walang paghihintay, at walang mga internasyonal na bayad.",
        "okx": "okx",
        "客户端下载":
            "Download Client",
        "UID不能为空": "Hindi maaaring walang laman ang UID",
        "提现方式": "Baguhin ang pagbago",
        "recommendclass": "Inirerekomendang kategorya",
        "滑动验证": "Mag-swipe para i-verify",
        "subOrder": "Magsumite ng order",
        "最多上传9张图片": "Hanggang 9 na larawan ang maaaring i-upload",
        "账号注销": "pagkansela ng account",
        "确定注销": "kumpirmahin ang pag-logout",
        "您的账号": "ang iyong akawnt",
        "为什么要离开": "bakit umalis",
        "您还有余额,不能注销账号": "May balanse ka pa, hindi makansela ang account!",
        "请输入注销理由": "Mangyaring maglagay ng dahilan para sa pagkansela!",
        "您确认要注销吗?": "Sigurado ka bang gusto mong mag-log out?",
        "我再考虑下": "Pag-iisipan ko",
        "同意注销": "sumang-ayon na mag-logout",
        "注销成功": "matagumpay ang pag-logout",
        "请先选择币种": "Mangyaring pumili ng uri ng pera",
        "开户行": "Bank of deposit",
        "请输入开户行名称": "Mangyaring magpasok ng pangalan ng bank ng deposito",
        "银行卡号": "Bank card number",
        "请输入银行卡号": "Mangyaring magpasok ng numero ng bank card",
        "点击去支付": "Mag-click upang magbayad",
        "企业证明": "Katibayan ng negosyo",
        "cancelInfo": "balaan! Mangyaring mag-ingat sa pagkansela ng account. Kung hindi mo na ginagamit ang account, maaari mong i-click ang [Sumasang-ayon sa Pagkansela]. Maaaring hindi ka makapagrehistro sa loob ng ilang araw pagkatapos ng pagkansela.",
        "App下载(买家端)": "Pag-download ng app (panig ng mamimili)",
        "App下载(卖家端)": "Pag-download ng app (panig ng nagbebenta)",
        "请选择": "mangyaring pumili",
        "提款地址绑定": "Nagbubuklod ang withdrawal address",
        "绑定成功": "matagumpay na magbigkis",
        "仅能绑定一个收款地址!": "Isang receiving address lang ang maaaring itali!",
        "最多包含10位小数": "Naglalaman ng hanggang 10 na decimal na lugar",
        "footTipTikTok": "CoveBuy ©️2024 Copyright",
        "长时间未付款，系统自动取消订单": "Matagal na hindi nabayaran, awtomatikong kinansela ng system ang order",
        "企业电话": "Telephone number ng negosyo",
        "加密货币": "Cryptocurrency",
        "职业机会": 
            "Mga karagdagang pag-career",
        "银行卡": "Bank card",
        "充值币种": "Recharge currency",
        '参数缺失': "Nawawala ang parameter",
        '充值数量必填': "Ang dami ng pag-recharge ay kinakailangan",
        "充值金额": "Recharge amount",
        "充值金额不得小于": "The recharge amount shall not be less than",
        "充值金额不得大于": "The recharge amount shall not be greater than",
        "TikTokFoot": "Ang CoveBuy ay isang pandaigdigang short video social platform na CoveBuy at Alibaba, ang pinakamalaking wholesale trading company sa Asia, na magkasamang itinatag. Isa itong pandaigdigang platform ng e-commerce at may tatlong self-operated na smart warehouse sa mundo, na matatagpuan sa Toronto, Canada, Los Angeles, at Chiba, Japan. Kasama sa mga produktong ibinebenta sa app ang mga sikat na produkto mula sa Japan, South Korea, China at iba pang mga bansa sa Asya. Sa kasalukuyan, ang kabuuang bilang ay lumampas sa 50,000 at patuloy na lumalaki nang mabilis.",
        "betaBannerText": "Ang website ay nasa public beta testing, mangyaring huwag mag-order"
    }